import { GET_MY } from '../../containers/App/constants';

import {
  FILTER_DEFAULT_LIMIT,
  REQUEST_CREATE_PRODUCT,
  REQUEST_PRODUCT,
  REQUEST_PRODUCTS_BY_INVOICE,
  REQUEST_PRODUCT_SEARCH,
  REQUEST_UPDATE_PRODUCT,
  INITIATE_PRODUCT_EDIT,
  REQUEST_PRODUCTS_FILTER,
  REQUEST_PRODUCT_DOWNLOAD,
  SET_NEW_PRODUCT_VALUE,
  REQUEST_GET_COUNTERS,
  REQUEST_PRODUCTS,
  REQUEST_PRODUCT_COMPANY_FIN_DATA,
  REQUEST_UPDATE_PRODUCT_COMPANY_FIN_DATA,
  REQUEST_CREATE_PRODUCT_CUSTOM_FIN_DATA,
  REQUEST_COMPANY_PRODUCTS_FILTER,
  REQUEST_DELETE_COMPANY_PRODUCT_CUSTOMIZATION,
  REQUEST_DELETE_COMPANY_PRODUCT,
  REQUEST_ADD_COMPANY_PRODUCT,
  REQUEST_COMPANY_PRODUCTS_IDS,
  REQUEST_COMPANY_PRODUCT,
  REQUEST_UPDATE_COMPANY_PRODUCT_CUSTOMIZATION,
  REQUEST_ADD_COMPANY_PRODUCT_CUSTOMIZATION,
  REQUEST_DELETE_PRODUCT_TASK, REQUEST_ADD_PRODUCT_TASK, REQUEST_GET_PRODUCT_TASKS, REQUEST_GET_ALL_PRODUCT_TASKS,
} from './constants';
import { buildUrlWithQueryParams } from '../../utils/helpers/url';

export function fetchProducts(options = {}, callback = () => {}, offset = 0, limit = FILTER_DEFAULT_LIMIT) {
  return {
    type: REQUEST_PRODUCTS_FILTER,
    options,
    callback,
    limit,
  };
}

export function fetchAllProducts(options = {}, callback) {
  const path = buildUrlWithQueryParams('products', { offset: 0, limit: 1000, ...options });
  return {
    type: GET_MY,
    id: REQUEST_PRODUCTS,
    work: REQUEST_PRODUCTS,
    gate: REQUEST_PRODUCTS,
    path,
    callback,
  };
}

export function changeProductFilter(name, value) {
  return {
    type: REQUEST_PRODUCTS_FILTER,
    name,
    value,
  };
}

export function fetchProductsByInvoice(invoiceId, vehiclePurposeType, text, offset = 0, callback) {
  let path = `products?offset=${offset}&limit=${10}${text ? `&text=${text}` : ''}${
    vehiclePurposeType ? `&vehiclePurposeType=${vehiclePurposeType}` : ''
  }`;
  path += `&filters[${0}][key]=invoice_id&filters[${0}][type]=single&filters[${0}][value][${0}]=${invoiceId}`;
  return {
    type: GET_MY,
    id: REQUEST_PRODUCTS_BY_INVOICE,
    work: REQUEST_PRODUCTS_BY_INVOICE,
    gate: REQUEST_PRODUCTS_BY_INVOICE,
    path,
    callback,
  };
}

export function createProduct(data, callback) {
  return {
    type: GET_MY,
    id: REQUEST_CREATE_PRODUCT,
    callback,
    work: REQUEST_CREATE_PRODUCT,
    gate: REQUEST_CREATE_PRODUCT,
    path: `products`,
    post: data,
  };
}

export function updateProduct(productId, data, callback) {
  return {
    type: GET_MY,
    id: REQUEST_UPDATE_PRODUCT,
    callback,
    work: REQUEST_UPDATE_PRODUCT,
    gate: REQUEST_UPDATE_PRODUCT,
    path: `products/${productId}`,
    patch: data,
    putOnComplete: [fetchProduct(productId), fetchProducts()],
  };
}

export function initiateProductEdit(id) {
  return {
    type: INITIATE_PRODUCT_EDIT,
    id,
  };
}

export function fetchProduct(productId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_PRODUCT,
    callback,
    work: REQUEST_PRODUCT,
    gate: REQUEST_PRODUCT + productId,
    path: `products/${productId}`,
  };
}

export function productSearch(string, vehiclePurposeType, options, callback) {
  let path = `products?limit=100&text=${string}`;
  if (vehiclePurposeType) {
    path += `&vehiclePurpose=${vehiclePurposeType}`;
  }
  if (options.companyId) {
    path += `&companyId=${options.companyId}`;
  }

  return {
    type: GET_MY,
    work: REQUEST_PRODUCT_SEARCH,
    callback,
    path,
  };
}

export function downloadProductPDF(productId, callback, purchaseStatement) {
  const path = `invoice/${productId}/pdf`;
  return {
    type: GET_MY,
    work: `${REQUEST_PRODUCT_DOWNLOAD}-${productId}`,
    gate: `${REQUEST_PRODUCT_DOWNLOAD}-${productId}`,
    path,
    callback,
  };
}

export function setNewProductValue(name, value) {
  return {
    type: SET_NEW_PRODUCT_VALUE,
    name,
    value,
  };
}

export function getCounters(callback) {
  return {
    type: GET_MY,
    id: REQUEST_GET_COUNTERS,
    gate: REQUEST_GET_COUNTERS,
    work: REQUEST_GET_COUNTERS,
    path: 'products/additional/vehicle-counters',
    callback,
  };
}

export function fetchProductCompanyFinData(productId, companyId) {
  return {
    type: GET_MY,
    id: REQUEST_PRODUCT_COMPANY_FIN_DATA,
    work: REQUEST_PRODUCT_COMPANY_FIN_DATA,
    gate: REQUEST_PRODUCT_COMPANY_FIN_DATA + productId + companyId,
    path: `products/${productId}/for-company/${companyId}`,
  };
}

export function updateProductCompanyFinData(productId, companyId, dto) {
  return {
    type: GET_MY,
    id: REQUEST_UPDATE_PRODUCT_COMPANY_FIN_DATA,
    patch: dto,
    work: REQUEST_UPDATE_PRODUCT_COMPANY_FIN_DATA,
    gate: REQUEST_UPDATE_PRODUCT_COMPANY_FIN_DATA + productId + companyId,
    path: `products/${productId}/for-company/${companyId}`,
    putOnComplete: [fetchProductCompanyFinData(productId, companyId)],
  };
}

export function createProductCustomFinData(productId, dto, callback) {
  return {
    type: GET_MY,
    id: REQUEST_CREATE_PRODUCT_CUSTOM_FIN_DATA,
    post: dto,
    work: REQUEST_CREATE_PRODUCT_CUSTOM_FIN_DATA,
    gate: REQUEST_CREATE_PRODUCT_CUSTOM_FIN_DATA + productId,
    path: `products/${productId}/custom-fin-data`,
    callback,
  };
}

export function fetchCompanyProduct(companyId, productId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_COMPANY_PRODUCT,
    work: REQUEST_COMPANY_PRODUCT,
    gate: REQUEST_COMPANY_PRODUCT + companyId + productId,
    path: `company-products/company/${companyId}/product/${productId}`,
    callback,
  };
}

export function fetchCompanyProducts(
  companyId,
  options = {},
  callback = () => {},
  offset = 0,
  limit = FILTER_DEFAULT_LIMIT,
) {
  return {
    type: REQUEST_COMPANY_PRODUCTS_FILTER,
    name: 'companyId',
    value: companyId,
    options,
    callback,
  };
}

export function fetchCompanyProductsIds(companyId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_COMPANY_PRODUCTS_IDS,
    work: REQUEST_COMPANY_PRODUCTS_IDS,
    gate: REQUEST_COMPANY_PRODUCTS_IDS + companyId,
    path: `company-products/company/${companyId}/allIds`,
    callback,
  };
}

export function changeCompanyProductsFilter(name, value) {
  return {
    type: REQUEST_COMPANY_PRODUCTS_FILTER,
    name,
    value,
  };
}

export function addCompanyProduct(companyId, productId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_ADD_COMPANY_PRODUCT,
    post: {},
    work: REQUEST_ADD_COMPANY_PRODUCT,
    gate: REQUEST_ADD_COMPANY_PRODUCT + companyId + productId,
    path: `company-products/company/${companyId}/product/${productId}`,
    callback,
    putOnComplete: [changeCompanyProductsFilter()],
  };
}

export function deleteCompanyProduct(companyId, productId, callback) {
  return {
    type: GET_MY,
    id: REQUEST_DELETE_COMPANY_PRODUCT,
    delete: {},
    work: REQUEST_DELETE_COMPANY_PRODUCT,
    gate: REQUEST_DELETE_COMPANY_PRODUCT + companyId + productId,
    path: `company-products/company/${companyId}/product/${productId}`,
    callback,
    putOnComplete: [changeCompanyProductsFilter()],
  };
}

export function addCompanyProductCustomization(companyId, productId, dto, options, callback) {
  return {
    type: GET_MY,
    id: REQUEST_ADD_COMPANY_PRODUCT_CUSTOMIZATION,
    post: dto,
    work: REQUEST_ADD_COMPANY_PRODUCT_CUSTOMIZATION,
    gate: REQUEST_ADD_COMPANY_PRODUCT_CUSTOMIZATION + companyId + productId,
    path: `company-products/company/${companyId}/product/${productId}/customization/`,
    callback,
    putOnComplete: [fetchCompanyProduct(companyId, productId)],
  };
}

export function updateCompanyProductCustomization(companyId, productId, customId, dto, options, callback) {
  return {
    type: GET_MY,
    id: REQUEST_UPDATE_COMPANY_PRODUCT_CUSTOMIZATION,
    patch: dto,
    work: REQUEST_UPDATE_COMPANY_PRODUCT_CUSTOMIZATION,
    gate: REQUEST_UPDATE_COMPANY_PRODUCT_CUSTOMIZATION + companyId + productId + customId,
    path: `company-products/company/${companyId}/product/${productId}/customization/${customId}`,
    callback,
    putOnComplete: [fetchCompanyProduct(companyId, productId)],
  };
}

export function deleteCompanyProductCustomization(companyId, productId, customId, options, callback) {
  return {
    type: GET_MY,
    id: REQUEST_DELETE_COMPANY_PRODUCT_CUSTOMIZATION,
    delete: {},
    work: REQUEST_DELETE_COMPANY_PRODUCT_CUSTOMIZATION,
    gate: REQUEST_DELETE_COMPANY_PRODUCT_CUSTOMIZATION + companyId + productId + customId,
    path: `company-products/company/${companyId}/product/${productId}/customization/${customId}`,
    callback,
    putOnComplete: [options.reloadDetailsPage ? fetchCompanyProduct(companyId, productId) : changeCompanyProductsFilter()],
  };
}

export function getAllProductTasks() {
  return {
    type: GET_MY,
    id: REQUEST_GET_ALL_PRODUCT_TASKS,
    work: REQUEST_GET_ALL_PRODUCT_TASKS,
    gate: REQUEST_GET_ALL_PRODUCT_TASKS,
    path: `products/product-tasks`,
  };
}

export function getProductTasks(productId) {
  return {
    type: GET_MY,
    id: REQUEST_GET_PRODUCT_TASKS,
    work: REQUEST_GET_PRODUCT_TASKS,
    gate: REQUEST_GET_PRODUCT_TASKS + productId,
    path: `products/${productId}/tasks`,
  };
}

export function addProductTask(productId, task) {
  return {
    type: GET_MY,
    id: REQUEST_ADD_PRODUCT_TASK,
    post: { task },
    work: REQUEST_ADD_PRODUCT_TASK,
    gate: REQUEST_ADD_PRODUCT_TASK + productId + task,
    path: `products/${productId}/tasks`,
    putOnComplete: [getProductTasks(productId)],
  };
}

export function deleteProductTask(productId, task) {
  return {
    type: GET_MY,
    id: REQUEST_DELETE_PRODUCT_TASK,
    delete: {},
    work: REQUEST_DELETE_PRODUCT_TASK,
    gate: REQUEST_DELETE_PRODUCT_TASK + productId + task,
    path: `products/${productId}/tasks/${task}`,
    putOnComplete: [getProductTasks(productId)],
  };
}
